import '../../style.scss';
import { MultiSelections, MultiSelectionsDataProps } from 'views/mutual/inputRadio';
import { JpEntityClassification, NffeClassification } from '../hooks';
import { Caption } from 'views/mutual/caption';


export type OverseasFatcaResponseSelectionProps = {
  jpEntityClassificationSelectionsProps: MultiSelectionsDataProps,
  nffeClassificationSelectionsProps: MultiSelectionsDataProps,
}

type OverseasRealEstateFatcaResponseProps = {
  selectionProps : OverseasFatcaResponseSelectionProps,
}
type JpEntityClassificationSelectionsProps = OverseasFatcaResponseSelectionProps;
type NffeClassificationSelectionsProps = {
  nffeClassificationSelectionsProps: MultiSelectionsDataProps;
};

export const OverseasRealEstateFatcaType = ({selectionProps} : OverseasRealEstateFatcaResponseProps) => {  

  return (
    <div className="response">
      <div>
        <Caption label="２．米国納税義務（FATCA）の概要" />
        <div className='summary'>
            <span className='summary_description'>
                {'・FATCA（Foreign Account Tax Compliance Act）とは、米国納税義務者が、米国以外の金融機関の口座を利用し米国の税金を逃れることを防止するために制定されたものです。'}
            </span>
            <span className='summary_description'>
                {'・FATCAに基づく対応は、国内法である「犯罪による収益の移転防止に関する法律」に基づく取引時確認とは別に求められているものです。'}
            </span>
        </div>
      </div>
      <div className="response_description-wrapper">
          <span className="response_description-wrapper_description jpEntityClassification">
            {'以下の事項につき該当する箇所（１）（２）（３）いずれかにチェック（✓）を入れてください。'}
          </span>
          <span className="response_description-wrapper_description jpEntityClassification">
            {'なお（２）に該当する場合は、項目内の該当する箇所へもチェック（✓）をお願いします。'}
          </span>
      </div>
      <JpEntityClassificationSelections
        jpEntityClassificationSelectionsProps={selectionProps.jpEntityClassificationSelectionsProps}
        nffeClassificationSelectionsProps={selectionProps.nffeClassificationSelectionsProps}
      />
      <div className="response_comment-wrapper">
        <span className="response_comment-wrapper_comment">
          {'・上記記載内容について正確であることを宣誓します。'}
        </span>
        <span className="response_comment-wrapper_comment">
          {'・上記記載内容に変更があった場合には、30日以内に連絡いたします。'}
        </span>
      </div>
    </div>          
  );
}

const JpEntityClassificationSelections = ({jpEntityClassificationSelectionsProps, nffeClassificationSelectionsProps} : JpEntityClassificationSelectionsProps) => {
  return (
    <div className='overseas-real-estate-fatca_multi-selections-wrapper'>      
      <MultiSelections
        items={[
          { label: '（１）当社は日本国内金融機関です。', 
            value: JpEntityClassification.JapanFinancialInstitution, 
          },
          { label: '（２）当社は日本法人（金融機関および非営利法人を除く）です。', 
            value: JpEntityClassification.JapanCorporationGeneral,
            additional: jpEntityClassificationSelectionsProps.selected === JpEntityClassification.JapanCorporationGeneral && 
            (
              <NffeClassificationSelections 
                nffeClassificationSelectionsProps={nffeClassificationSelectionsProps}
               />
            )
          },
          { label: '（３）当社は（１）および（２）に該当しません。', 
            value: JpEntityClassification.Other,
            additional:
            <div className="response_description-wrapper_description small">
              {'※米国法人、非営利法人、日本国外金融機関、その他の外国法人である場合はこちらにチェックをいれてください。'}
            </div>},
        ]}
        name="jpEntityClassification"
        {...jpEntityClassificationSelectionsProps}
      />
    </div>
  );
};

const NffeClassificationSelections = ({nffeClassificationSelectionsProps} : NffeClassificationSelectionsProps) => {
  return (
    <div className='overseas-real-estate-fatca_multi-selections-wrapper nffe-classification'>
      <div className="response_description-wrapper nffe-classification">
      <span className="response_description-wrapper_description small">
          {'※以下のいずれかをご選択ください。'}
        </span>
      </div>
        
        <MultiSelections
          items={[
            { label: '当社は能動的NFFEです。', value: NffeClassification.ActiveNffe, additional: 
              <>
              <div className="response_description-wrapper nffe-classification">
                <span className="response_description-wrapper_description small">
                  {'※前事業年度総収入のうち、受動的収入（利息、配当、ロイヤルティなどの投資収入をいう。以下同じ。）が占める割合が50%未満であり、かつ、保有資産のうち、受動的収入を生み出す資産または受動的収入生産のために保有されている資産の割合が50%未満である場合はこちらにチェックを入れてください。'}
                </span>
              </div>
              </>
            },
            { label: <span>{'当社は能動的NFFEではない（受動的NFFEである）可能性があります 。'}</span>, value: NffeClassification.PassiveNffe, 
            },
          ]}
          name="nffeClassification"
          {...nffeClassificationSelectionsProps}
        />        
      </div>
  );
};